import 'gridstrap/svg-symbols/squircle.svg?sprite';
import 'gridstrap/svg-symbols/star.svg?sprite';
import 'gridstrap/components/bottom-bar/bottom-bar.scss';

import { components } from 'gridstrap/lib/gs-components';
import { SCWaitlistBottomBar } from './waitlist-bottom-bar';

components.register({
	selector: '.sc-WaitlistBottomBar',
	controller: SCWaitlistBottomBar
});
